import React from 'react';
import FeaturedCarousel from '../featured-carousel/FeaturedCarousel';

class SlideBar extends React.Component {
  render() {
    return (
      <div className="featured-panel">
        <div className="featured-panel__carousel">
          <FeaturedCarousel />
        </div>
      </div>
    );
  }
}

export default SlideBar;
